import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ServicioToastService } from 'src/app/services/servicio-toast.service';
import { FiltrosFormatoAsistencialEntity, ServicioFormatoAsistencialService } from '../../../services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-header-formato-asistencial',
  templateUrl: './header-formato-asistencial.component.html',
  styleUrls: ['./header-formato-asistencial.component.css']
})
export class HeaderFormatoAsistencialComponent implements OnChanges {

  canLoad: boolean; // Indicador si es posible ver o no la impresion

  canImpresion: boolean; // Indicador si es posible imprimir

  loading: boolean; // Indicador de carga en header

  loadingImpresion: boolean; // Indicador de impresion

  mensajeError: string; // String para mensaje error

  display: { evolucion: boolean; servicio: boolean; afiliado: boolean, archivo: boolean } = {
    evolucion : true,
    servicio : true,
    afiliado : true,
    archivo : true
  };

  @Input() public filtros: FiltrosFormatoAsistencialEntity;

  @Output() filtrosSeleccionados: EventEmitter<any>;

  constructor(private servicioFormato: ServicioFormatoAsistencialService,
              private servicioToast: ServicioToastService) {
    this.loading = true;
    this.loadingImpresion = false;
    this.filtrosSeleccionados = new EventEmitter();

    this.servicioFormato.temporalNodos.subscribe((nextValue: any) => {
      if (nextValue) {
        const data: any[] = JSON.parse(nextValue);
        if (data && data.length > 0) {
          this.loadingImpresion = true;
        } else {
          this.loadingImpresion = false;
        }
      }
    });
  }

  ngOnChanges() {
    this.setImpresion();
    this.onGenerar();
    this.setDisplay();
  }

  onDiligenciados(value: boolean) {
    this.filtros.diligenciados = value;
  }

  onEvoluciones(value: boolean) {
    this.filtros.evoluciones = value;
  }

  onFirmaProfesional(value: boolean) {
    this.filtros.firmaProfesional = value;
  }

  onFirmaAfiliado(value: boolean) {
    this.filtros.firmaAfiliado = value;
  }

  onNotas(value: boolean) {
    this.filtros.notas = value;
  }

  onArchivo(value: boolean) {
    this.filtros.archivo = value;
  }

  onServicios(value: boolean) {
    this.filtros.solicitudServicios = value;
  }

  setImpresion() {
    this.canLoad = this.filtros.login.activaImpresion >= 1;
    this.canImpresion = this.filtros.login.activaImpresion === 2;
  }

  setDisplay() {
    const isPregunta = this.filtros.pregunta && this.filtros.pregunta > 0;
    this.display.evolucion = !isPregunta;
    this.display.servicio = !isPregunta;
    this.display.afiliado = !isPregunta;
    this.display.archivo = !isPregunta;
  }

  // Listener

  onGenerar() {
    const obj: FiltrosFormatoAsistencialEntity = {
      archivo : this.filtros.archivo,
      codigoBaseDatos : this.filtros.codigoBaseDatos,
      diligenciados : this.filtros.diligenciados,
      firmaAfiliado : this.filtros.firmaAfiliado,
      firmaProfesional : this.filtros.firmaProfesional,
      marcaAgua : this.filtros.marcaAgua,
      notas : this.filtros.notas,
      solicitudServicios : this.filtros.solicitudServicios,
      tta : this.filtros.tta,
      uncoLogin : this.filtros.uncoLogin,
      sede : this.filtros.sede,
      user : this.filtros.user,
      evoluciones : this.filtros.evoluciones,
      login : this.filtros.login,
      canLoad : this.canLoad,
      canImpresion : this.canImpresion,
      pregunta : this.filtros.pregunta
    };
    this.filtrosSeleccionados.emit(obj);
  }

  onImprimir() {

    const wait = this.servicioFormato.getTemporalWait();
    if (wait && wait.length > 0) {
      this.servicioToast.addError('El reporte aún no se encuentra listo, se esta procesando las siguientes preguntas: ' + wait.toUpperCase());
      return;
    }

    let printContents: any, popupWin: any;

    printContents = document.getElementById('historia-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link href="https://fonts.googleapis.com/css?family=Gentium+Basic" rel="stylesheet">
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">
          <link rel="stylesheet" href="https://unpkg.com/ngx-bootstrap/datepicker/bs-datepicker.css">
          <link rel="stylesheet" href="assets/css/historia-print.css"/>
        </head>
        <body onload="window.print();">
        <table>
          <thead>
            <tr>
              <td>
                <div class="header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content"> ${ printContents } </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="header"></div>
        <div class="footer">
            <span>&copy; 2021 - sqlsimens.com.co</span>
        </div>
        </body>
      </html>`
    );

    popupWin.document.close();
  }

  onDescargarPDF() {

  }

}
